export default "__VITE_ASSET__d2078b71__"